module.exports = __webpack_public_path__ + "static/media/lb-mac.3cac5ed4.svg";